// extracted by mini-css-extract-plugin
module.exports = {"root":"html-block_root__KIKkK"};